import { useSelector } from 'react-redux';
import type { TrustBannerProps } from '@noths/polaris-design-system-candidate-components';

import { trackTrustBannerImpression } from 'src/components/molecules/TrustBanner/tracking/trustBannerEvents';
import { selectTrustBannerContent } from 'src/redux/content/selectors';

/**
 * View model for the trust banner. Owns the content read and the impression
 * tracking, so the presentational banner stays pure props.
 *
 * Returns null when there is no banner content, which is how the section is
 * omitted from the page.
 */
export interface TrustBannerViewModel extends TrustBannerProps {
  onVisible: VoidFunction;
}

export const useTrustBannerViewModel = (): TrustBannerViewModel | null => {
  const content = useSelector(selectTrustBannerContent);

  if (!content) {
    return null;
  }

  const { trackingTitle, ...trustBannerProps } = content;

  return {
    ...trustBannerProps,
    onVisible: () => trackTrustBannerImpression(trackingTitle || content.headline),
  };
};
